export function canUserSaveColumnTemplateForAll(user: { superuser: boolean }) {
	return user.superuser;
}
